import React             from 'react';
import { Collapse }      from 'react-bootstrap';
import CheckboxComponent from './CheckboxComponent';

const SectionAdvancedSpecs = (props) => (
  <div className="card advanced-specs mb-3">
    <div className="card-header">
      <CheckboxComponent
        inputId="has_advanced_specs"
        name="has_advanced_specs"
        label="Advanced Specs."
        checked={props.parameters.has_advanced_specs === '1'}
        onChange={e => props.onChangeParameter('has_advanced_specs', e.target.checked ? '1' : '0')} />
    </div>
    <Collapse in={props.parameters.has_advanced_specs === '1'}>
      <div className="card-body">
        {props.children}
      </div>
    </Collapse>
  </div>
);

export default SectionAdvancedSpecs;
